import i18nMessages from 'dashboard/i18n';

const MESSAGE_KEYS = {
  contact: 'CONTACT_ACTIVE_CONVERSATION_BLOCKED',
  contactUnassigned: 'CONTACT_ACTIVE_CONVERSATION_BLOCKED_UNASSIGNED',
};

const interpolate = (template, params = {}) =>
  template.replace(/%\{(\w+)\}/g, (_, key) => params[key] ?? '');

export const getEffectiveLocaleFromStore = store => {
  const uiSettings = store.getters.getUISettings;
  const accountId = store.getters.getCurrentAccountId;
  const account = accountId
    ? store.getters['accounts/getAccount'](accountId)
    : null;

  return uiSettings?.locale || account?.locale || 'en';
};

const formatBlockedMessage = (key, locale, params = {}) => {
  const messages =
    i18nMessages[locale]?.CONVERSATION || i18nMessages.en.CONVERSATION;
  const template = messages[key] || i18nMessages.en.CONVERSATION[key];
  return interpolate(template, params);
};

export const getAssigneeName = conversation => {
  const assignee = conversation?.meta?.assignee;
  return assignee?.available_name || assignee?.name || null;
};

export const getContactActiveConversationBlockedMessage = (
  locale,
  agentName = null
) => {
  if (!agentName) {
    return formatBlockedMessage(MESSAGE_KEYS.contactUnassigned, locale);
  }

  return formatBlockedMessage(MESSAGE_KEYS.contact, locale, { agentName });
};

const normalizeId = value => Number(value);

export const getContactId = conversation =>
  conversation?.meta?.sender?.id ?? conversation?.contact_id;

export const isRestrictionEnabledForInbox = (inboxId, inboxes = []) => {
  const inbox = inboxes.find(
    item => normalizeId(item.id) === normalizeId(inboxId)
  );
  return Boolean(inbox?.restrict_agent_single_open_conversation);
};

const mergeConversation = (conversations, conversation) => {
  if (!conversation) return conversations;

  const alreadyIncluded = conversations.some(
    item => normalizeId(item.id) === normalizeId(conversation.id)
  );

  return alreadyIncluded ? conversations : [...conversations, conversation];
};

export const getContactActiveConversationsInInbox = ({
  inboxId,
  contactId,
  conversations = [],
  selectedConversation = null,
}) => {
  if (!contactId) return [];

  const normalizedInboxId = normalizeId(inboxId);
  const normalizedContactId = normalizeId(contactId);

  const activeConversations = conversations.filter(
    conversation =>
      normalizeId(conversation.inbox_id) === normalizedInboxId &&
      normalizeId(getContactId(conversation)) === normalizedContactId &&
      conversation.status !== 'resolved'
  );

  if (
    selectedConversation &&
    normalizeId(selectedConversation.inbox_id) === normalizedInboxId &&
    normalizeId(getContactId(selectedConversation)) === normalizedContactId &&
    selectedConversation.status !== 'resolved'
  ) {
    return mergeConversation(activeConversations, selectedConversation);
  }

  return activeConversations;
};

export const canCreateConversationForContactInInbox = ({
  inboxId,
  contactId,
  conversations = [],
  inboxes = [],
  selectedConversation = null,
}) => {
  if (!isRestrictionEnabledForInbox(inboxId, inboxes)) return true;

  return (
    getContactActiveConversationsInInbox({
      inboxId,
      contactId,
      conversations,
      selectedConversation,
    }).length === 0
  );
};
